import { FormControl, ValidationErrors } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { isObservable } from "rxjs";

export function AutocompleteOptionValidator(control: FormControl, field: FormlyFieldConfig): ValidationErrors {
  if (!control.value) {
    return null;
  }

  const options = field.templateOptions?.options;

  // We can only validate against arrays synchronously
  if (Array.isArray(options)) {
    // Check if value exists in options (by value property)
    const isValidOption = options.some((option: any) => option.value === control.value);

    if (!isValidOption) {
      return { autocompleteInvalid: true };
    }
  }

  return null;
}
